import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

/**
 * @param {{ variant: 'company' | 'user' }} props
 */
export function MicrosoftIntegrationExplainer({ variant }) {
  const { t } = useTranslation();
  const keys =
    variant === "company"
      ? [
          "microsoft.explain.company.1",
          "microsoft.explain.company.2",
          "microsoft.explain.company.3",
          "microsoft.explain.company.4",
          "microsoft.explain.company.5",
        ]
      : [
          "microsoft.explain.user.1",
          "microsoft.explain.user.2",
          "microsoft.explain.user.3",
          "microsoft.explain.user.4",
          "microsoft.explain.user.5",
        ];

  return (
    <div className="rounded-xl border border-sky-200/80 bg-sky-50/90 p-4 sm:p-5">
      <div className="flex gap-3">
        <InformationCircleIcon
          className="h-6 w-6 shrink-0 text-sky-600"
          aria-hidden
        />
        <div className="min-w-0 space-y-2">
          <h3 className="text-sm font-semibold text-sky-950">
            {t("microsoft.explain.title")}
          </h3>
          <ul className="list-disc space-y-1.5 pl-4 text-sm text-sky-950/90">
            {keys.map((k) => (
              <li key={k}>{t(k)}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
